import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import teamModel from './teamModel'

const {
  fetchList,
  fetchAll,
  fetchOne,
  create,
  update,
  deleteMany,
} = useModelStoreModule(teamModel)

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchList,
    fetchAll,
    fetchOne,
    create,
    update,
    deleteMany,
  },
}
